module.exports = __webpack_public_path__ + "img/9788981171230.9cd06afe.jpg";